export default __webpack_public_path__ + "static/media/app_proposal_landing_page_image.f15bb4d9.png";